import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';

// Styles
import styles from './textBlock.css';

/**
 * A simple pairing of title and text.
 * @param  {string} options.title        The heading of this block.
 * @param  {number} options.headingLevel Which h tag should wrap the title.
 * @param  {string} options.text         The text to display/
 * @return {object}                      Component jsx.
 */
const TextBlock = ({
  title,
  headingLevel,
  text,
  classNames: { titleClassName = '', textClassName = '' },
}) => {
  const HeadingTag = `h${headingLevel}`;
  return (
    <div className={styles.textBlock}>
      {title &&
        <HeadingTag
          className={classNames(styles.title, titleClassName)}
        >
          {title}
        </HeadingTag>
      }
      <ReactMarkdown
        className={classNames(styles.text, textClassName)}
        source={text}
      />
    </div>
  );
};

TextBlock.defaultProps = {
  headingLevel: 3,
  title: false,
  classNames: {},
};

TextBlock.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  headingLevel: PropTypes.number,
  text: PropTypes.string.isRequired,
  classNames: PropTypes.shape({
    titleClassName: PropTypes.string,
    textClassName: PropTypes.string,
  }),
};

export default TextBlock;



// WEBPACK FOOTER //
// ./app/components/textBlock/index.js